import React from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet } from 'react-native';

import { useColors } from '../../hooks';
import { ContinueButton } from '../continue-button/continue-button';

interface LessonButtonProps {
  i18nKey: string;
  animated: boolean;
  animationDuration: number;
  onPress: () => void;
  children?: React.ReactNode;
}

const LessonButton: React.FC<LessonButtonProps> = ({
  i18nKey,
  animated,
  animationDuration,
  onPress,
}) => {
  const { t } = useTranslation();
  const colors = useColors();

  return (
    <ContinueButton
      animationDuration={animationDuration}
      animated={animated}
      onPress={onPress}
      hasSafeArea={false}
      action={t(i18nKey) as string}
      successColor={colors.primary}
      containerStyle={[
        { backgroundColor: colors.offWhite },
        Platform.OS !== 'web' && styles.container,
      ]}
    />
  );
};

export default LessonButton;

const styles = StyleSheet.create({
  container: {
    paddingVertical: 20,
  },
});
